module.exports = __webpack_public_path__ + "img/undraw_analyze_17kw.a3fcda69.svg";